"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.LikeIcon = exports.LikedIcon = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ThumbsUpOutline = _interopRequireDefault(require("../../theme/icons/ThumbsUpOutline"));

var _ThumbsUp = _interopRequireDefault(require("../../theme/icons/ThumbsUp"));

var _Button = _interopRequireDefault(require("../Button"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: 100%;\n  height: 40px;\n  border-radius: 0px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n    color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var defaultSpacing = (0, _styledComponents.css)(_templateObject(), _spacing["default"][2]);
var LikedIcon = (0, _styledComponents["default"])(_ThumbsUp["default"])(_templateObject2(), defaultSpacing);
exports.LikedIcon = LikedIcon;
var LikeIcon = (0, _styledComponents["default"])(_ThumbsUpOutline["default"])(_templateObject3(), defaultSpacing, _colors["default"].blackberry[100]);
exports.LikeIcon = LikeIcon;
var Button = (0, _styledComponents["default"])(_Button["default"])(_templateObject4());
exports.Button = Button;